import { DeleteTheme, LoadThemeMaps, LoadThemes, UpsertTheme } from '../../connection/themes';
import { THEME_FILTER } from '../reducers/themes';
import { Theme } from '../types/themes';
import { Action, AsyncAction } from '../types/types';

export const LOAD_THEMES = "LOAD_THEMES";
export function loadThemes(channel: number, stylepack: string): AsyncAction {
	return {
		type: LOAD_THEMES,
		promise: LoadThemes(channel, stylepack),
		meta: {stylepack}
	} as AsyncAction
}

export const UPSERT_THEME = "UPSERT_THEME";
export function upsertTheme(channel: number, theme: Partial<Theme>): AsyncAction {
	return {
		type: UPSERT_THEME,
		promise: UpsertTheme(channel, theme),
	} as AsyncAction
}

export const DELETE_THEME = "DELETE_THEME";
export function deleteTheme(themeId: number): Action {
	return {
		type: DELETE_THEME,
		payload: themeId,
	}
}

export const SET_EDITING_THEME = "SET_EDITING_THEME";
export function setEditingTheme(themeId: number | null, isEditing: boolean): Action {
	return {
		type: SET_EDITING_THEME,
		payload: {themeId, isEditing}
	}
}

export const ATTACH_THEME = "ATTACH_THEME";
export function attachTheme(uniqueId: string, themeId: number | null): Action {
	return {
		type: ATTACH_THEME,
		payload: {uniqueId, themeId}
	}
}

export const SET_CREATING_THEME = "SET_CREATING_THEME";
export function setCreatingTheme(stylepack: string, currItemUniqueId: string): Action {
	return {
		type: SET_CREATING_THEME,
		payload: {stylepack, currItemUniqueId}
	}
}

export const SET_THEME_FILTER = "SET_THEME_FILTER";
export function setThemeFilter(filter: THEME_FILTER): Action {
	return {
		type: SET_THEME_FILTER,
		payload: filter
	}
}

export const LOAD_THEME_MAPS = "LOAD_THEME_MAPS";
export function loadThemeMaps(): AsyncAction {
	return {
		type: LOAD_THEME_MAPS,
		promise: LoadThemeMaps(),
	} as AsyncAction
}